import { render, staticRenderFns } from "./discussDetail.vue?vue&type=template&id=78dd2f54&scoped=true"
import script from "./discussDetail.vue?vue&type=script&lang=js"
export * from "./discussDetail.vue?vue&type=script&lang=js"
import style0 from "./discussDetail.vue?vue&type=style&index=0&id=78dd2f54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dd2f54",
  null
  
)

export default component.exports